module.exports = __webpack_public_path__ + "img/resource-ya-active.f6d2476d.png";